import { logger } from "../../../log";

export const log = logger("sw");
